export type P0WorkflowStep = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type P0StepStatus = "pending" | "current" | "done";

export interface P0WorkflowState {
    linkedDocCount: number;
    comments: string;
    savedComments: string;
    questionCount: number;
    allRequiredFilled: boolean;
    hasBriefing: boolean;
    isApproved: boolean;
}

export function getP0CurrentStep(state: P0WorkflowState): P0WorkflowStep {
    if (state.linkedDocCount < 1) return 1;
    if (state.comments !== state.savedComments) return 3;
    if (state.questionCount === 0) return 4;
    if (!state.allRequiredFilled) return 5;
    if (!state.hasBriefing) return 6;
    return 7;
}

export function isP0StepDone(step: P0WorkflowStep, state: P0WorkflowState): boolean {
    switch (step) {
        case 1:
            return state.linkedDocCount >= 1;
        case 2:
            return state.linkedDocCount >= 1;
        case 3:
            return state.comments === state.savedComments;
        case 4:
            return state.questionCount > 0;
        case 5:
            return state.allRequiredFilled;
        case 6:
            return state.hasBriefing;
        case 7:
            return state.isApproved;
        default:
            return false;
    }
}

export function getP0StepStatus(
    step: P0WorkflowStep,
    state: P0WorkflowState,
): P0StepStatus {
    const current = getP0CurrentStep(state);
    if (isP0StepDone(step, state) && step !== current) return "done";
    if (step === current) return "current";
    if (step < current && isP0StepDone(step, state)) return "done";
    return "pending";
}

/** Accent colors per step (current state uses these; done uses emerald). */
export const P0_STEP_ACCENT: Record<P0WorkflowStep, string> = {
    1: "bg-sky-600",
    2: "bg-indigo-500",
    3: "bg-violet-600",
    4: "bg-blue-700",
    5: "bg-amber-600",
    6: "bg-teal-600",
    7: "bg-emerald-700",
};
